export class OsteoporosisCalculations {
    update(){

    }
}


// WEBPACK FOOTER //
// ./src/forms/dxaScan01/Calculations/Osteoporosis-Calculations.js